import React, {Fragment, useContext, useEffect, useState} from "react";
import {ServerContext} from "../../serverContext/ServerProvider";
import {Loader} from "../../components/Loader";
import {Text} from "../../components/inputs/Text";
import {TextArea} from "../../components/inputs/TextArea";
import {NotificatorContext} from "../../components/Notificator";

export const Specs = ({good}) => {
    const {getSpecs, specs, updateSpecs} = useContext(ServerContext)
    const {showNotification} = useContext(NotificatorContext)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        async function wtf() {
            await getSpecs(good.specs, () => setLoading(false))
        }

        wtf()
    }, [])

    useEffect(() => {
        if (!loading && specs) {
            init()
        }
    }, [specs, loading])

    const [titles, setTitles] = useState([])
    const [params, setParams] = useState([])

    const init = () => {
        console.log(specs)
        specs.map(spec => {
            setTitles(prev => prev.concat([spec.title]))
            setParams(prev => prev.concat([spec.options]))
            return spec
        })
    }

    const addSpec = () => {
        setParams(prev => prev.concat([['Default value']]))
        setTitles(prev => prev.concat(['Default title']))
    }

    const removeSpec = (index) => {
        setParams(prev => prev.filter((a, i) => i !== index))
        setTitles(prev => prev.filter((a, i) => i !== index))
    }

    const addParam = (index) => {
        setParams(prev => prev.map((param, i) => {
            if (index === i) {
                return param.concat([' '])
            }
            return param
        }))
    }

    const removeParam = ({optionIndex, paramIndex}) => {
        setParams(prev => prev.map((params, i) => {
            if (i === optionIndex) {
                return params.filter((param, j) => j !== paramIndex)
            }
            return params
        }))
    }

    const setTitle = (newValue, {index}) => {
        setTitles(prev => prev.map((value, i) => {
            if (i === index) {
                return newValue
            }
            return value
        }))
    }

    const setOption = (newValue, args) => {
        setParams(prev => prev.map((params, index) => {
            if (index === args.optionIndex) {
                return params.map((param, i) => {
                    if (i === args.paramIndex) {
                        return newValue
                    }
                    return param
                })
            }
            return params
        }))
    }

    const save = () => {
        const toSave = {
            pages: titles.map((title, index) => {
                return {
                    title,
                    options: params[index]
                }
            })
        }
        updateSpecs(good.specs, toSave, () => showNotification('Changes have been saved on server'))
    }

    return (
        <Fragment>
            {loading ? <Loader/> : (
                <Fragment>
                    <div className='container pl-0 pt-5 editor_container'>
                        {titles.map((title, index) => (
                            <div key={index} className="row  mt-5 editor_subcontainer">
                                <div className="col-4 text-muted pt-1 pb-1">
                                    <Text
                                        state={title}
                                        setState={setTitle}
                                        setterArgs={{index}}
                                    />
                                </div>
                                {params[index].map((param, paramI) => (
                                    <div key={paramI}
                                         className={`col-${Math.trunc(8 / params[index].length)} text-dark`}>
                                        <TextArea
                                            state={param}
                                            setState={setOption}
                                            removeHandler={(params[index].length > 1) ? removeParam : null}
                                            setterArgs={{
                                                paramIndex: paramI,
                                                optionIndex: index
                                            }}
                                        />
                                    </div>
                                ))}
                                <div className="col-6 pt-1 ">
                                </div>
                                <div className="col-3 align-self-end pt-1 ">
                                    <button className="float-left" onClick={() => addParam(index)}>Add field
                                    </button>
                                </div>
                                <div className="col-3 align-self-end pt-1 ">
                                    <button
                                        className='remove_button'
                                        onClick={() => removeSpec(index)}
                                    >Remove SPEC
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <button className="save_button float-left" onClick={addSpec}>Add one</button>
                    <button className='save_button float-right' onClick={save}>Save</button>
                </Fragment>
            )}
        </Fragment>
    )
}